<template>
    <div :class="`messagelistwrap size-${$mq}`" @keydown="doKeyDown" tabindex="0">
        <vue-headful :title="title"></vue-headful>
        <message-list-control-bar class="controls"
                :folderid="folderid" :rights="rights"
                :selectedUIDs="selectedUIDs" :messages="messages"
                :showRefresh="showRefresh" :outqueueShowSent="outqueueShowSent"
                :start="start" :filteredLength="filteredLength" :actualLength="messages.length"
                :totalLength="totalFolderSize" :pageLength="pageLength"
                @search="$emit('search', $event)" @page="$emit('page', $event)"
                @updateMessages="$emit('updateMessages', $event)"
                @deleteMessages="$emit('deleteMessages', $event)"
                @selectAll="$emit('selectAll', $event)"
                @moveMessages="$emit('moveMessages', $event)"
                @menu="$emit('menu', $event)" @check="$emit('check', $event)"/>
        <!--<message-control-bar v-show="displayMessage && 0" @hide="hideMessage"
                @delete="deleteCurrentMessage"
                @markUnread="markCurrentMessageUnread"
                @move="moveCurrentMessage"/>-->
        <!--<message-pager :pageLength="pageLength" class="pager"
                :start="start" :filteredLength="filteredLength"
                :actualLength="messages.length"
                :totalLength="totalFolderSize"
                :selectedUIDs="selectedUIDs"
                @page="$emit('page', $event)"></message-pager>-->

        <div ref="messagelist" v-touch:swipe="doSwipe"
            tabindex="0" role="grid" aria-label="Message List" class="messagelist"
            aria-multiselectable="true" aria-readonly="true"
            :class="{ normalfolder: folderId > 0, outboxfolder: folderId === -1, quarantinefolder: folderId === -2 }"
            :aria-activedescendant="`msglist-${keyboardSelectIndex}`">
            <div :class="`messagelist2 size-${$mq}`" fluid>
                <message-line v-for="(m, ind) in messages" :key="m.uid" :message="m"
                        :ref="`msg-${ind}`"
                        :index="ind" :sentFolder="sentFolder"
                        :folder="folderId" @show="$emit('showMessage', { uid: m.uid, evt: $event })"
                        :selected="selectedUIDs[m.uid]"
                        :lastSelected="ind===selectIndex"
                        :keyboardSelect="ind===keyboardSelectIndex"
                        @messageUpdated="$emit('messageUpdated', $event)"
                        @selectMessage="$emit('selectMessage', $event)"/>
            </div>
        </div>
    </div>
</template>

<script>
import MessageLine from '@/components/messageLine';
import MessageListControlBar from '@/components/messageListControlBar';
import Modernizr from 'modernizr';

export default {
  name: 'msgListView',
  components: { MessageLine, MessageListControlBar },
  data() {
    return {
      keyboardSelectIndex: 0
    };
  },
  props: {
    folderid: String,
    messages: Array,
    selectedUIDs: Object,
    selectIndex: Number,
    rights: {
      type: String,
      required: true
    },
    showRefresh: Boolean,
    outqueueShowSent: Boolean,
    start: {
      type: Number,
      required: true
    },
    totalFolderSize: {
      type: Number,
      required: true
    },
    pageLength: {
      type: Number,
      required: true
    },
    filteredLength: {
      type: Number,
      required: true
    }
  },
  methods: {
    doSwipe(evt) {
      if (Modernizr.touch) {
        console.log('swipe', evt);
        if (evt === 'right') {
          this.$emit('page', this.start - this.pageLength);
        } else if (evt === 'left') {
          this.$emit('page', this.start + this.pageLength);
        }
      }
    },
    doKeyDown(evt) {
      console.log('keydown', evt);
      const oldSelect = this.keyboardSelectIndex;
      if (evt.key === 'ArrowDown') {
        this.keyboardSelectIndex++;
      } else if (evt.key === 'ArrowUp') {
        this.keyboardSelectIndex--;
      } else if (evt.key === 'PageDown') {
        this.keyboardSelectIndex += 10;
      } else if (evt.key === 'PageUp') {
        this.keyboardSelectIndex -= 10;
      } else if (evt.key === 'Home') {
        this.keyboardSelectIndex = 0;
      } else if (evt.key === 'End') {
        this.keyboardSelectIndex = this.messages.length - 1;
      } else if (evt.key === 'Enter') {
        this.$emit('showMessage', this.messages[this.keyboardSelectIndex].uid);
      } else if (evt.key === ' ') {
        this.$emit('selectMessage', { folder: this.folderId,
          uid: this.messages[this.keyboardSelectIndex].uid,
          shift: evt.shiftKey });
        evt.preventDefault();
      } else if ((evt.key === 'a') && (evt.ctrlKey)) {
        if (this.messages.length > 0) {
          this.$emit('selectAll', !this.selectedUIDs[this.messages[0].uid]);
        }
        evt.preventDefault();
      } else if ((evt.key === 'ArrowRight') && (evt.ctrlKey)) {
        this.$emit('page', this.start + this.pageLength);
      } else if ((evt.key === 'ArrowLeft') && (evt.ctrlKey)) {
        this.$emit('page', this.start - this.pageLength);
      }
      if (oldSelect !== this.keyboardSelectIndex) {
        evt.preventDefault();
      }
      this.keyboardSelectIndex = Math.max(0, Math.min(this.keyboardSelectIndex, this.messages.length - 1));

      if (oldSelect !== this.keyboardSelectIndex) {
        console.log(this.$refs);
        console.log(this.$refs[`msg-${this.keyboardSelectIndex}`]);
        this.$refs[`msg-${this.keyboardSelectIndex}`][0].$el.scrollIntoView({ behaviour: 'smooth', block: 'nearest' });
      }
    }
  },
  computed: {
    folderId() {
      return parseInt(this.folderid, 10);
    },
    sentFolder() {
      if (this.folderId === -1) {
        return true;
      }
      return false;
    },
    title() {
      return this.$t('messageList.htmlTitle', { user: this.$store.state.username,
        name: this.$store.getters.getFolderById(this.folderId).name });
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .messagelistwrap {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 50px minmax(0, 1fr);
        grid-template-areas: "controls" "messages";
        &.size-sm {
            grid-template-columns: 1fr;
            grid-template-rows: auto minmax(0, 1fr);
            grid-template-areas: "controls" "messages";
        }
        .controls {
            grid-area: controls;
        }
        .pager {
            grid-area: pager;
        }
        .messagelist {
            grid-area: messages;
            height: calc(100vh - 90px);
            padding-left: 5px;
            animation-duration: 0.2s;
            font-size: $message-list-size;
            overflow-y: scroll;
        }
    }

</style>
